export const update = (
    eventId = ':event',
    bookingId = ':booking',
    guestId = ':guest'
) => `/events/${eventId}/artists/bookings/${bookingId}/guests/${guestId}/edit`;
